import {
    faAngleUp,
    faBezierCurve,
    faCaretDown,
    faCheck,
    faCircle,
    faCircleCheck,
    faCircleExclamation,
    faCircleSmall,
    faCircleStar,
    faCircleUser,
    faEllipsisVertical,
    faImageCirclePlus,
    faImages,
    faLockKeyhole,
    faLockKeyholeOpen,
    faPencil,
    faRobot,
    faRotateRight,
    faShoppingBasket,
    faText,
    faTriangleExclamation,
    faUser,
    faUserSecret,
    faX,
    type IconDefinition,
} from "@fortawesome/pro-solid-svg-icons";

export const solidIcons: IconDefinition[] = [
    faBezierCurve,
    faCaretDown,
    faCircle,
    faCircleCheck,
    faCircleExclamation,
    faCheck,
    faRobot,
    faText,
    faUser,
    faUserSecret,
    faShoppingBasket,
    faImages,
    faImageCirclePlus,
    faEllipsisVertical,
    faAngleUp,
    faLockKeyhole,
    faLockKeyholeOpen,
    faPencil,
    faRotateRight,
    faCircleStar,
    faCircleSmall,
    faCircleUser,
    faTriangleExclamation,
    faX,
];
